import React from 'react';
import { Image, Row } from '@thd-olt-component-react/core-ui';
import { useNavigate } from '@thd-olt-component-react/router';
import { EXP_ROUTES, tradeTypeAbbreviated, tradeTypeIconMap } from '../../../utils/constants';
import { generateImageSource } from '../../../utils/generateImageSource';

export const JobTemplateCategory = ({ tradeType, jobTemplates }) => {

  const navigate = useNavigate();

  const renderTemplateLinks = () => {

    return jobTemplates?.map((jobTemplate) => (
      <div
        className="ptp-job-template__template-link"
        key={jobTemplate.jobTemplateId}
        onClick={() => { navigate(EXP_ROUTES.JOB_TEMPLATE(jobTemplate.jobTemplateId)); }}
        data-testid={`template-link-${jobTemplate.jobTemplateId}`}
      >
        {jobTemplate.yearsOfExperience.substring(0, jobTemplate.yearsOfExperience.search(/\d/))} {tradeTypeAbbreviated?.[jobTemplate.tradeType] || jobTemplate.tradeType}
      </div>
    )
    );
  };

  const renderTradeTypeIcon = () => {

    return (
      <Image
        src={generateImageSource(`/images/v1/path-to-pro/tradeTypes/${tradeTypeIconMap?.[tradeType] || 'residentialRemodeling'}.svg`)}
        className="ptp-job-template__template-icon"
        alt="trade icon"
        data-testid="tradeTypeIcon"
      />
    );
  };

  return (
    <Row className="ptp-job-template__tradetype-category">
      {renderTradeTypeIcon()}
      <div>
        <span className="ptp-job-template__tradetype-title">
          {tradeType}
        </span>
        {renderTemplateLinks()}
      </div>
    </Row>
  );
};
